import { createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pb-6 px-0 sm:px-6 sm:shadow-sm" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "text-center text-2xl text-gray-800 sm:text-gray-600 font-header mb-8" }, " Welcome Back ", -1)
const _hoisted_3 = { class: "my-4" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "py-4 px-6 sm:bg-gray-100 flex flex-row justify-center sm:justify-end items-center" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Forgot Password? ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Alert = _resolveComponent("Alert")
  const _component_Input = _resolveComponent("Input")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_LoaderIcon = _resolveComponent("LoaderIcon")
  const _component_Form = _resolveComponent("Form")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.error.display)
        ? _createVNode(_component_Alert, {
            key: 0,
            type: "error",
            message: _ctx.error.message
          }, null, 8, ["message"])
        : _createCommentVNode("", true),
      _createVNode(_component_Form, {
        valid: _ctx.valid,
        "onUpdate:valid": _cache[5] || (_cache[5] = $event => (_ctx.valid = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Input, {
            label: "Email",
            value: _ctx.form.email.value,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => (_ctx.form.email.value = $event)),
            rules: _ctx.form.email.rules
          }, null, 8, ["value", "rules"]),
          _createVNode(_component_Input, {
            label: "Password",
            type: "password",
            value: _ctx.form.password.value,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => (_ctx.form.password.value = $event)),
            rules: _ctx.form.password.rules
          }, null, 8, ["value", "rules"]),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Checkbox, {
              label: "Remember Me",
              value: _ctx.form.rememberMe.value,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => (_ctx.form.rememberMe.value = $event))
            }, null, 8, ["value"])
          ]),
          _createVNode("button", {
            onClick: _cache[4] || (_cache[4] = $event => (_ctx.login())),
            class: ["w-full py-2 rounded flex flex-row items-center justify-center", {
					'bg-secondary shadow-md': _ctx.valid && !_ctx.disableSubmit,
					'bg-gray-300 text-gray-600': !_ctx.valid || _ctx.disableSubmit,
				}],
            type: "button",
            disabled: !_ctx.valid || _ctx.disableSubmit
          }, [
            (_ctx.disableSubmit)
              ? _createVNode(_component_LoaderIcon, {
                  key: 0,
                  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-gray-600"
                })
              : _createCommentVNode("", true),
            (!_ctx.disableSubmit)
              ? (_openBlock(), _createBlock("span", _hoisted_4, "Login"))
              : _createCommentVNode("", true)
          ], 10, ["disabled"])
        ]),
        _: 1
      }, 8, ["valid"])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, {
        class: "text-gray-700 underline text-sm hover:no-underline",
        to: { name: 'forgot-password' }
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ], 64 /* STABLE_FRAGMENT */))
}